import React from 'react'
import { useNavigate } from 'react-router-dom'
const BackButton = () => {

    const navigate = useNavigate()

    const goBack = () => {
        navigate(-1)
    }
  return (
    <div onClick={goBack} role='button' className='ms-3 mb-3'>
        <i className="fas fa-arrow-left fa-back-button "></i>
    </div>
  )
}

export default BackButton